module.exports = __webpack_public_path__ + "static/media/notify_icon.db4cf4eb.svg";